<template>
	<div>
		<div class="row mb-2">
			<div class="col-12 col-lg-9">
				<h1>{{$t('osce-dashboard')}}</h1>               

			</div>
			<div class="col-12 col-lg-3 float-right text-right">
			</div>
		</div>
		<div class="row" v-if="ready">
			<div class="col-12 col-lg-9">
                <!-- <ReportWidget
                    :settings="{
                        header: 'osce-progress',
                        reportroute: 'oscestudent'
                    }"
                    class="mb-4"
                /> -->
                <h1>{{ $t('current-stations') }}</h1>
                <Table
                    v-if="stations.length"
                    :loading="loading"
                    :submitting="submitting"
                    :cols="[
                        { key: 'oscestation_code', heading: $t('station-id'), size: 2 },
                        { key: 'examiners', heading: $t('examiners'), size: 1 },
                        { key: 'students', heading: $t('students'), size: 1 },
                        { key: 'not_started', heading: $t('not-started'), size: 2 },
                        { key: 'in_progress', heading: $t('in-progress'), size: 2 },
                        { key: 'completed', heading: $t('completed'), size: 1 },
                        { key: 'aborted', heading: $t('aborted'), size: 1 },
                        //{ key: 'alert', heading: $t('alerts'), size: 2},
                    ]"
                    :data="stations"
                    breakpoint="md"
                    @selectItem="selectItem"
                    :filters="{}"
                    :scrollPaginate="true"
                    @refresh="refresh"
                    @toPage="toPage"
                    :searchable="false"
                    class="mb-4"
                >
                
                	<!--
					<template #col-alert="{ item }">
						<Alerts :values="item.score"
						/>
					</template>
					-->
	
					<!--
					<template v-slot:header>
						 <div class="list-group-item align-items-center">
	
							<div class="form-inline">
								<SelectInput
									v-model="year"
									:options="[1,2,3,4]"
									:label="$t('year')"
									:srOnly="true"
									:nullable="true"
									:nullLabel="$t('year')"
									class="ml-2 mr-2 align-items-center"
								/>
								<SelectInput
									v-model="period"
									:label="$t('period')"
									:options="[1,2,3,4,5]"
									:srOnly="true"
									:nullable="true"
									:nullLabel="$t('period')"
									class="ml-2 mr-2 align-items-center"
								/>
							   
							</div>
	
						</div>
					</template>
					-->
                </Table>
			</div>
			<div class="col-12 col-lg-3">
                <h1>{{ $t('messages') }}</h1>
				<div class="card mb-8">
					<OSCEChat 
						@new-message="handleNewMessage"
						:canCleanUpNotifications="true"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Table from "src/components/Table/Table.vue";
import OSCEChat from "../../components/OSCE/OSCEChat.vue";
//import Alerts from "../../components/OSCE/Alerts.vue";

export default {
	components: {
        Table,
        OSCEChat
        //Alerts
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		}
	},
	mounted() {
		this.getStations()
	},
    data() {
        const today = new Date();
        const past = new Date(today);
        past.setDate(today.getDate() - 31);

        const future = new Date(today);
        future.setDate(today.getDate()+7);

        return {
            stations:[],
            total_count: 0,
            loading: false,
            submitting: false,
            showadvancedsearch:false,
            students:[],
            ready:false,
            
            debounceTimerId: undefined,
			debounceTime:  15000,
            
            year: null,
            period: null
            //item:{}
        }
    },
    methods: {
    	handleNewMessage() {
    	
    	},
    	getStations() {

            return this.$cfetch(`${this.$settings.APIBaseURL}/osce/adminstations`, {
                data: {
                }
            })
            .then((json) => {
				if (json.status == 'SUCCESS') {
					this.stations = json.stations
					this.ready = true
                	this.autoUpdate()
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
    	
    	},
        selectItem(item){
        	//this.$router.push(`/osce/examiner/`);
        	this.$router.push(`/osce/examiner/${item.osceevent_id}/${item.oscestation_id}`);
        },
        scoreIcon(item){
            if(item.score >= 90) return { icon: 'exclamation-triangle-fill', variant: 'success' };
            if(item.score <= 50) return { icon: 'exclamation-triangle-fill', variant: 'danger' };
            return { icon: 'exclamation-triangle-fill', variant: 'warning'}
        },
		
		autoUpdate(){
            if (this.debounceTimerId) clearTimeout(this.debounceTimerId)
			if (this.debounceoff == true){
				return;
			}
            this.debounceTimerId = setTimeout(() => {
                this.getStations()
                this.debounceTimerId = null
            }, this.debounceTime)
		},
        
        /*
        refresh(filters) {
            this.filters = { ...this.filters, ...filters, page: 1 }
            this.fetchReport()
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.fetchReport()
        }
        */
    }
};
</script>
